module.exports = __webpack_public_path__ + "static/media/img_2.15abb8d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_2.jpg
// module id = 538
// module chunks = 0